import { createTheme, responsiveFontSizes } from '@mui/material';
import './declare';

let theme = createTheme();

theme = responsiveFontSizes(theme);

export default theme;
